import { render, staticRenderFns } from "./ModalFormFastAnswers.vue?vue&type=template&id=396cfcc9&scoped=true&"
import script from "./ModalFormFastAnswers.vue?vue&type=script&lang=js&"
export * from "./ModalFormFastAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396cfcc9",
  null
  
)

export default component.exports